import { render, staticRenderFns } from "./SelectCompanies.vue?vue&type=template&id=2a21bcba&scoped=true&"
import script from "./SelectCompanies.vue?vue&type=script&lang=js&"
export * from "./SelectCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21bcba",
  null
  
)

export default component.exports